import './src/styles/global.css'
import './src/scripts/global.js'
